import React from 'react';
import {useTranslation} from 'react-i18next';
import AiAgentStarIcon from '../../../../assets/icons/AiAgentStarIcon';
import * as css from './AiAgentFeedback.css';

const STAR_VALUES = [1, 2, 3, 4, 5];

interface AiAgentFeedbackStarsProps {
    value: number;
    disabled?: boolean;
    onChange: (value: number) => void;
}

/** Five plain buttons — a radio group would owe arrow-key navigation this row does not have. */
function AiAgentFeedbackStars({value, disabled = false, onChange}: AiAgentFeedbackStarsProps) {
    const {t} = useTranslation('aiAgent');

    return (
        <css.starsRow>
            {STAR_VALUES.map(star => {
                const active = star <= value;
                return (
                    <css.starButton
                        key={star}
                        type="button"
                        aria-pressed={star === value}
                        aria-label={t('feedbackStar', {value: star})}
                        $active={active}
                        disabled={disabled}
                        onClick={() => onChange(star)}
                        data-cy={`ai-agent-feedback-star-${star}`}
                    >
                        <AiAgentStarIcon fill={active ? 'currentColor' : 'none'} />
                    </css.starButton>
                );
            })}
        </css.starsRow>
    );
}

export default AiAgentFeedbackStars;
